import React from 'react';

import OfferPriceDropdown from '@components/offer-price/OfferPriceDropdown';

const OfferPriceListItem = ({ offerPriceInfo }) => {
	let offerPriceValue;

	if (offerPriceInfo.length === 1) {
		offerPriceValue = `O: $${offerPriceInfo[0].offerPrice.toFixed(2)}`;
	} else {
		const minPrice = Math.min(...offerPriceInfo.map((item) => item.offerPrice));
		const maxPrice = Math.max(...offerPriceInfo.map((item) => item.offerPrice));
		offerPriceValue = `O: ($${minPrice.toFixed(2)}-$${maxPrice.toFixed(2)})`;
	}
	return (
		<li className="offer-price position-static">
			<span className="semibold-12">{offerPriceValue}</span>
			<OfferPriceDropdown offerPriceInfo={offerPriceInfo} />
		</li>
	);
};

export default OfferPriceListItem;
